import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.css']
})
export class AccountNavComponent implements OnInit {

  @Input() email: string = '';
  @Input() name: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
